import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box, Button, IconButton, Stack, Tab, Tabs } from "@mui/material"
import React, { useEffect, useState, useRef } from "react"
//import MetricTable from "../../../MetricTable"
import GroupMetricTable from "../GroupMetricTable"
import { useDispatch, useSelector } from "react-redux"
import { LeftIcon, RightIcon, StyledTab } from "./Atom"
import {
  setSelectAllDisableCheck,
  setSelectedBucket,
  setSelectedBucketDetails,
  setSelectedIndex,
} from "../../../../redux/slices/groupProfileSlice"

// const tabData = [
//   "Production",
//   "Collections",
//   "Accounts Receivables",
//   "Recall/Recare",
//   "Marketing",
//   "Treatment Plans",
//   "Communication",
//   "Schedule",
//   "Clinical Excellence",
// ]

function MetricDetails() {
  const dispatch = useDispatch()

  const [selectedTab, setSelectedTab] = React.useState("0")
  const [selectedBucketName, setSelectedBucketName] = useState(null)
  const AllData = useSelector((state: any) => {
    return state.groupProfile.groupProfileDetails
  })
  const selectedBucket = useSelector((state: any) => {
    return state.groupProfile.selectedBucket
  })
  const selectedBucketDetails = useSelector((state: any) => {
    return state.groupProfile.selectedBucketDetails
  })
  const handleChangeTab = (event: React.SyntheticEvent, newValue: any) => {
    setSelectedTab(newValue)
  }

  const tabData = useSelector((state: any) => {
    return state.groupProfile.metricDetailsBuckets
  })
  let disableArray: any = []
  const indDetailsFetchHandler = () => {
    AllData?.filter((ele: any, index: any) => {
      if (ele.metric_bucket === selectedBucket) {
        dispatch(setSelectedIndex(index))
        dispatch(setSelectedBucketDetails(ele))
        ele?.metrics.forEach((eleItem: any) => {
          if (eleItem.isAssigned === true) {
            disableArray.push(eleItem.isAssigned)
          }
        })
      }
    })
  }
  const DisableCheckHandler = () => {
    AllData?.filter((ele: any, index: any) => {
      if (ele.metric_bucket === selectedBucket) {
        if (ele?.metrics?.length === disableArray.length) {
          dispatch(setSelectAllDisableCheck(true))
        } else {
          dispatch(setSelectAllDisableCheck(false))
        }
      }
    })
  }
  useEffect(() => {
    indDetailsFetchHandler()
    DisableCheckHandler()
  }, [selectedBucket])

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        position: "relative",
        "& .MuiTabPanel-root": {
          padding: "0px",
        },
        flexGrow: 1,
        minWidth: {
          xs: "100%",
          sm: "100%",
          md: "100%",
          lg: "100%",
          xl: "100%",
        },
        maxWidth: {
          xs: 320,
          sm: "600px",
          md: "600px",
          lg: "564px",
          xl: "600px",
        },
      }}
    >
      <TabContext value={selectedTab}>
        <Tabs
          value={selectedTab === "0" ? 0 : selectedTab}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Tabs"
          onChange={handleChangeTab}
          TabIndicatorProps={{
            sx: { maxWidth: "34px", height: "4px" },
          }}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            // marginLeft: "29px",
            //padding: "0px 15px",
            fontFamily: "Poppins",
            // overflowX: "scroll",
            // overflowY: "scroll"
            // height: "10%",
          }}
        >
          {tabData?.map((tab: any, index: any) => (
            <StyledTab
              key={index}
              label={tab}
              //value={index}
              //defaultChecked={index === 0}
              disableRipple
              onClick={() => {
                setSelectedBucketName(tab)
                dispatch(setSelectedBucket(tab))
                indDetailsFetchHandler()
                DisableCheckHandler()
              }}
            />
          ))}
        </Tabs>

        <TabPanel value={selectedTab}>
          <GroupMetricTable />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
export default MetricDetails
